var SanitizeFileName = require('sanitize-filename');


module.exports = {

    urlEndSlash: function(url) {
        var lastChar = url.charAt(url.length-1);
        url = (lastChar !== '/') ? url  + '/' : url;
        return url;
    },
    formatNumber: function (n, decPlaces, thouSeparator, decSeparator) {
        var decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
            decSeparator = decSeparator === undefined ? "." : decSeparator,
            thouSeparator = thouSeparator === undefined ? "," : thouSeparator,
            sign = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return sign + (j ? i.substr(0, j) + thouSeparator : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) + (decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
    },
    getFileNameFromPath: function(path) {
       return path.split('/').pop();
    },
    rotatePt: function(pt, deg, sx, sy) {  //deg -- give radian
        var a = this.degreeToRadian(deg);
        return {
            x:  sx + Math.cos(a) * (pt.x - sx) - Math.sin(a) * (pt.y - sy),
            y:  sy + Math.sin(a) * (pt.x - sx) + Math.cos(a) * (pt.y - sy)
        };
    },
    degreeToRadian: function(deg) {
        return deg * (Math.PI / 180);
    },
    stripFileExtension: function(filename) { //return filename without ext
        return filename.substr(0, filename.lastIndexOf('.'));
    },
    getFileExtension: function(filePath) {
        return filePath.split('.').pop();
    },
    createClass: function(name, rules) { //works with legacy IEs
        var style = document.createElement('style');
        style.type = 'text/css';
        document.getElementsByTagName('head')[0].appendChild(style);
        if(!(style.sheet||{}).insertRule)
            (style.styleSheet || style.sheet).addRule(name, rules);
        else
            style.sheet.insertRule(name+"{"+rules+"}",0);
    },
    getStyleSheetPropertyValue: function(selectorText, propertyName) {
        // search backwards because the last match is more likely the right one
        for (var s= document.styleSheets.length - 1; s >= 0; s--) {
            var cssRules;

            try { /* Prevent cross domain errors from occuring in Mozilla -- just skip */
                cssRules = document.styleSheets[s].cssRules ||
                    document.styleSheets[s].rules || []; // IE support
            } catch(e) {
                continue;
            }

            for (var c=0; c < cssRules.length; c++) {
                if (cssRules[c].selectorText === selectorText) 
                    return cssRules[c].style[propertyName];
            }
        }
        return null;
    },
    /* Derives Initials from a Name from the first letter of each word, space separated, defaults to lowercase -- if no words, return empty str*/
    deriveInitials: function(fullName, toUpper) { //*todo extend underscore
        var inits =_.reduce(fullName.split(' '), function(memo, word) {
            return memo += word.charAt(0);
        }, '');
       return inits.length > 0 ? inits['to' + (!toUpper ? 'Lower' : 'Upper') + 'Case']()  : '';

    },
    /* NOTE: !!! IF TESTING IN COMPATIBILITY MODE, MUST CHANGE THE BROWSER MODE AS WELL AS THE COMPATIBILITY MODE */
    isIE7: function() {
        return (navigator.appVersion.indexOf("MSIE 7.") > -1);
    },
    isIE8: function() {
        return (navigator.appVersion.indexOf("MSIE 8.") > -1);
    },
    isIE9:  function() {
        return (navigator.appVersion.indexOf("MSIE 9.") > -1);
    },
    isIE8orIE9: function() {
        return this.isIE8() || this.isIE9();
    },
    isIE: function () {
        return (/trident/i).test(navigator.userAgent); /* as of IE11, no longer contains MSIE); http://msdn.microsoft.com/en-us/library/ie/bg182625%28v=vs.85%29.aspx */
    },
    isChrome: function () {
        return ( /chrome/.test(navigator.userAgent.toLowerCase()) );
    },
    isIntegerGreaterThanZero: function(pgNum) {
        // could optimize this when get time:

        if ( !isInteger(pgNum) ) return false; //could round if string and not numeric ...
        if ( pgNum < 1 ) return false;

        return true;
        //discussion here: http://2ality.com/2014/05/is-integer.html

        function isInteger(x) {
            return (typeof x === 'number') && (x % 1 === 0);
        }
    },
    // see https://24ways.org/2010/calculating-color-contrast
    // for given hexcolor background (assumes all 6 characters), return either dark or light color for overlay text
    // provides dark or light parameters to overide the default dark & light return colors
    getContrastYIQ: function(hexcolor, dark, light){

        hexcolor[0] === '#' && ( hexcolor = hexcolor.substr(1) );

        var r = parseInt(hexcolor.substr(0,2),16);
        var g = parseInt(hexcolor.substr(2,2),16);
        var b = parseInt(hexcolor.substr(4,2),16);

        var yiq = ((r*299)+(g*587)+(b*114))/1000;

        return (yiq >= 128)
            ? dark ? dark : '#000'
            : light ? light : '#fff';
    },

    /**
     * Adapted from // https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
     *
     */
    hexToRgba: function( hex, alpha ) {

        hex   = hex.replace('#', '');
        var r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
        var g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
        var b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);

        if ( alpha !== undefined ) {
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        }
        else {
            return 'rgb(' + r + ', ' + g + ', ' + b + ')';
        }

    },

    // Return unique string to apply to the name attribute of form input fields to prevent browsers' auto-complete.
    // According to https://github.com/terrylinooo/jquery.disableAutoFill, randomizeInputName,
    // ' preventing auto completion for all browsers (includes third-party auto-completeion extensions) not just for Google Chrome'
    // seems to work
    getUniqueStrToDisableFormAutoComplete: function() {
        return Math.random().toString(36).replace(/[^a-z]+/g, '');
    },
    /*
    * Wrapper around SanitizeFileName providing default options across the application.
    * Sanitize the name of file to be downloaded for the file system (vs URL escaping).
    * Left option to 'eliminateDupes' but this isn't the default -- the idea is if there
    * are consecutive invalid characters replaced, consolidate them with one replacement character.
    * FDD does this; I'm not doing it now b/c not it's that big a deal and the library I'm utilizing would need to be forked
    * to do this only for characters that were replaced.  The below would consolidate valid replacement characters (that
    * existed prior to replacing anything) and is not necessarily the desired functionality.
    * I could always do this later if requested.
    * */
    sanitizeFileNameForFileSystem: function(name, replacement, eliminateDupes) {

        var replaceWithChar = replacement ? replacement : '-';

        var sanitizedName = SanitizeFileName( name, {
            replacement: replaceWithChar
        } );

        if ( eliminateDupes ) {
            var regEx = new RegExp(replaceWithChar + '{2,}', 'g');
            sanitizedName = sanitizedName.replace(regEx, replaceWithChar);
        }


        return sanitizedName;
    },
    /*
    * Capitalize the first letter of each word in str.
    * */
    toTitleCase: function(str) {
        return str.replace( /\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    },
    /**
     * This returns a Javascript object that is JSON-like but isn't JSON -- it includes functions.
     * Use instead of JSON.stringify to keeps function values as JS objects.
     * Can't just use .toString on functions in JSON.stringify's replacer,
     * because that will surround the function with quotations.
     */
    jsonStringyWithFunctions: function(obj) {

        // Holds functions we encounter.
        var functions = [];
        var placeholder = ">>FN_PLACEHOLDER<<";

        // This handler just records a function object in `functions` and returns the
        // placeholder as the value to insert into the JSON structure.
        function replacer(key, value) {
            if (value instanceof Function) {
                functions.push(value);
                return placeholder;
            }

            return value;
        }

        // Stringify using the customer replacer.
        var pre = JSON.stringify(obj, replacer, 4);

        // Replace the placeholders in order they were encountered, with
        // the functions we've recorded.
        var post = pre.replace( new RegExp('"' + placeholder + '"', 'g'), function() {
            return functions.shift();
        });

        return post;

    },

    /* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping */
    escapeRegExp: function(string) {
        return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },

    // Could also use localeCompare IE11+ ( or more limited here )
    // but just use this now for better browser compatibility
    caseInsensitiveCompare: function( a, b ) {

        a = a.toLowerCase();
        b = b.toLowerCase();

        if ( a == b )
            return 0;

        if ( a > b )
            return 1;

        return -1;

    },

    /* Short-cut around mediation of events -- b/c a fn, could also be used for requests */
    blindForward: function( target, fnName ) {

        if ( !target || !target[fnName] || typeof target[fnName] !== 'function' ) {
            return;
        }

        return target[fnName].apply( target,  Array.prototype.slice.call(arguments, 2) );

    },

    /**
     * Normalize line breaks across OS as \n.
     * On Unix machines, a single newline character �n� does the job. On Macs, a carriage return �r� is used. DOS and Windows use both: �rn�.
     * Cold ( all stored as \n' ).
     * Raphael SVG export plugin expects \n .
     */
    normalizeNewLineCharacters: function( text ) {
        return text.replace(/(\r\n|\n|\r)/g,"\n");
    }


};





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/util.js
 ** module id = 48
 ** module chunks = 0
 **/